const discounts = {
	add_button: "Korting aanmaken",
	alerts: {
		discount_added: "Korting <strong>{{name}}</strong> succesvol toegevoegd!",
		discount_edited: "Korting <strong>{{name}}</strong> succesvol gewijzigd!",
	},
	calculate_dialog: {
		discount: "Korting",
		marge: "Marge",
		name: "Productnaam",
		price_purchase: "Kostprijs",
		price_recommended: "Adviesprijs",
		price_result: "Prijs",
	},
	create: {
		title: "Korting aanmaken",
	},
	delete_dialog: {
		description: "Weet u zeker dat u <strong>{{discount_label}}</strong> wilt verwijderen?",
		title: "Korting verwijderen",
	},
	edit: {
		title: "Korting bewerken",
	},
	form: {
		active: "Actief",
		all_debtors: "Iedereen",
		all_products: "Alle producten",
		amount: "Vast kortingsbedrag",
		and: "En",
		applies_to: "Geldt voor",
		debtor: "Debiteur",
		debtor_group: "Debiteurgroep",
		debtor_type: "Doelgroep",
		discount_type: "Type korting",
		duration_undetermined: "Onbepaalde tijd",
		if: "Als",
		information: "Informatie",
		label: "Kortingslabel",
		percentage: "Percentage",
		product: "Product",
		product_domain: "Domeinnaam (product)",
		product_group: "Productgroep",
		product_group_apply_to: {
			each_product: "Ieder product in product groep",
			product_group: "Op de totaalprijs van de product groep",
			title: "Korting toepassen op",
		},
		single_debtor: "Enkele debiteur",
		single_product: "Enkel product",
		then: "Dan",
		till: "Tot",
	},
	overview: "Kortingen overzicht",
	status: {
		create: {
			success: "Korting is succesvol toegevoegd!",
			unknown: "Korting kan op dit moment niet worden toegevoegd. Probeer het later opnieuw.",
		},
		delete: {
			success: "Korting is succesvol verwijderd!",
			unknown: "Korting kan op dit moment niet worden verwijderd. Probeer het later opnieuw.",
		},
		edit: {
			success: "Korting is succesvol gewijzigd!",
			unknown: "Korting kan op dit moment niet worden gewijzigd. Probeer het later opnieuw.",
		},
	},
	table: {
		debtor_type: "Doelgroep",
		details: "Details",
		id: "ID",
		label: "Label",
		product_type: "Geldt voor",
		table_items: {
			all_products: "Alle producten",
			everyone: "Iedereen",
		},
		type: "Soort korting",
	},
	title: "Kortingen",
};

export default discounts;
